import React from 'react';
import { motion } from 'framer-motion';
import { BellIcon, CheckCircleIcon, FlameIcon } from 'lucide-react';
const steps = [{
  num: '01',
  title: 'Get Prompted',
  desc: 'Ascension sends you a daily challenge from your task library.',
  icon: BellIcon
}, {
  num: '02',
  title: 'Complete the Task',
  desc: 'Before unlocking your apps, confirm that you completed the task.',
  icon: CheckCircleIcon
}, {
  num: '03',
  title: 'Build Your Streak',
  desc: 'Consistency compounds. Your streak becomes your accountability system.',
  icon: FlameIcon
}];
export function HowItWorksSection() {
  return <section className="py-24 bg-ascension-black relative" data-id="element-145">
      <div className="max-w-7xl mx-auto px-6" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-147">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-148">
            How Ascension Works
          </h2>
          <p className="text-ascension-gray max-w-2xl mx-auto" data-id="element-149">
            A simple, unbreakable system designed to eliminate friction and
            enforce daily action.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-150">
          {steps.map((step, index) => <motion.div key={step.num} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-ascension-dark rounded-2xl p-8 border border-white/5 hover:border-white/10 transition-colors relative overflow-hidden group" data-id="element-151">
              {/* Subtle background glow on hover */}
              <div className="absolute -inset-px bg-gradient-to-b from-ascension-green/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl pointer-events-none" data-id="element-152" />

              <div className="flex items-center justify-between mb-8 relative z-10" data-id="element-153">
                <div className="w-12 h-12 rounded-xl bg-ascension-black border border-white/10 flex items-center justify-center" data-id="element-154">
                  <step.icon className="text-ascension-green" size={24} data-id="element-155" />
                </div>
                <span className="text-4xl font-bold text-white/5" data-id="element-156">
                  {step.num}
                </span>
              </div>

              <h3 className="text-xl font-semibold text-white mb-3 relative z-10" data-id="element-157">
                {step.title}
              </h3>
              <p className="text-ascension-gray leading-relaxed relative z-10" data-id="element-158">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}